import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import CompanyTranslationGenerated from './CompanyTranslation.generated';
import CompanyTranslation from '../CompanyTranslation';


export class CompanyGeneratedEntityManager<BT extends CompanyTranslationGenerated, B extends CompanyGenerated<BT>> extends EntityWithTranslationManager<BT, B>
{
	translationEntityClass: any = CompanyTranslation;

    constructor(parameters: EntityWithTranslationManagerParameters<BT, B>)
    {
        super({
            name: parameters.name ?? 'Company',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'postalCode', type: BusinessEntityFieldType.VarChar },
				{ name: 'phone', type: BusinessEntityFieldType.VarChar },
				{ name: 'email', type: BusinessEntityFieldType.VarChar },
				{ name: 'websiteUrl', type: BusinessEntityFieldType.VarChar },
				{ name: 'vatRate', type: BusinessEntityFieldType.Decimal },
				{ name: 'vatNumber', type: BusinessEntityFieldType.VarChar },
				{ name: 'registrationNumber', type: BusinessEntityFieldType.VarChar },
				{ name: 'bankAccount', type: BusinessEntityFieldType.VarChar },
				{ name: 'bankName', type: BusinessEntityFieldType.VarChar },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'companies',
            translationsCustomGraphQlFields: 'name,officialName,addressLine1,addressLine2,cityName,regionName,countryName,socialMediaFacebook,socialMediaInstagram,socialMediaLinkedin,socialMediaYoutube,socialMediaTiktok',
        });
    }

}
export class CompanyGenerated<BT extends CompanyTranslationGenerated> extends BusinessEntityWithTranslation<BT>
{
	/** The postal code of the company. */
	postalCode: string = '';
	/** The main phone number of the company. */
	phone: string = '';
	/** The main email address of the company. */
	email: string = '';
	/** The website URL of the company. */
	websiteUrl: string = '';
	/** The VAT rate for the company (as percentage, e.g., 21.00). */
	vatRate: number | null = null;
	/** The VAT number of the company. */
	vatNumber: string = '';
	/** The registration number of the company. */
	registrationNumber: string = '';
	/** The bank account number of the company. */
	bankAccount: string = '';
	/** The name of the bank where the company has the account. */
	bankName: string = '';
	/** The name of the foreign key to the translated entity. */
	translationForeignKeyName: string = 'company';
	/** The primary language of the entity. */
	primaryLanguage: string = 'ro';

}

export default CompanyGenerated;